/* eslint-disable no-restricted-imports,no-duplicate-imports */
/**
 * Orderopatorio
 *
 * The version of the OpenAPI document: 0.15.6-SNAPSHOT
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import axios, { AxiosRequestConfig, RawAxiosRequestHeaders } from 'axios';
import {
  DUMMY_BASE_URL,
  getBaseUrl,
  serializeDataIfNeeded,
  setSearchParams,
  toPathString,
} from 'config/apiUtils';
import { AddCartItemRequest } from '../models';
import { CartItemResponse } from '../models';
import { CartResponse } from '../models';
import { UpdateCartCommentRequest } from '../models';
import { UpdateCartItemRequest } from '../models';

export type AddItemToCartParams = {
  addCartItemRequest: AddCartItemRequest;
  date?: string;
};

export type ClearCartParams = {
  date?: string;
};

export type DeleteCartParams = {
  date?: string;
};

export type GetCartForDateParams = {
  date?: string;
};

export type GetMyCartsForSpecifiedDatesParams = {
  cartDateFrom?: string;
  cartDateTo?: string;
};

export type RecreateCartFromOrderParams = {
  orderId: number;
};

export type RemoveItemFromCartParams = {
  itemId: number;
};

export type UpdateCartGeneralCommentParams = {
  updateCartCommentRequest: UpdateCartCommentRequest;
  date?: string;
};

export type UpdateCartItemQuantityParams = {
  itemId: number;
  updateCartItemRequest: UpdateCartItemRequest;
};

export const CartUserAPIApi = {
  addItemToCart(request: AddItemToCartParams) {
    const localVarRequestOptions: AxiosRequestConfig = { method: 'POST' };
    const { addCartItemRequest, date } = request;
    const localVarUrl = '/user/carts/items';
    const localVarUrlObj = new URL(localVarUrl, DUMMY_BASE_URL);
    const localVarHeaderParameter: RawAxiosRequestHeaders = {};
    const localVarQueryParameter: Record<string, any> = {};

    if (date !== undefined) {
      localVarQueryParameter['date'] =
        (date as any) instanceof Date
          ? (date as any).toISOString().substr(0, 10)
          : date;
    }

    localVarHeaderParameter['Content-Type'] = 'application/json';
    setSearchParams(localVarUrlObj, localVarQueryParameter);
    localVarRequestOptions.headers = { ...localVarHeaderParameter };
    localVarRequestOptions.data = serializeDataIfNeeded(
      addCartItemRequest,
      localVarRequestOptions,
    );
    const axiosRequestArgs = {
      ...localVarRequestOptions,
      url: getBaseUrl() + toPathString(localVarUrlObj),
    };
    return axios.request<CartItemResponse>(axiosRequestArgs);
  },

  clearCart(request: ClearCartParams = {}) {
    const localVarRequestOptions: AxiosRequestConfig = { method: 'DELETE' };
    const { date } = request;
    const localVarUrl = '/user/carts/clear';
    const localVarUrlObj = new URL(localVarUrl, DUMMY_BASE_URL);
    const localVarHeaderParameter: RawAxiosRequestHeaders = {};
    const localVarQueryParameter: Record<string, any> = {};

    if (date !== undefined) {
      localVarQueryParameter['date'] =
        (date as any) instanceof Date
          ? (date as any).toISOString().substr(0, 10)
          : date;
    }

    setSearchParams(localVarUrlObj, localVarQueryParameter);
    localVarRequestOptions.headers = { ...localVarHeaderParameter };
    const axiosRequestArgs = {
      ...localVarRequestOptions,
      url: getBaseUrl() + toPathString(localVarUrlObj),
    };
    return axios.request<void>(axiosRequestArgs);
  },

  deleteCart(request: DeleteCartParams = {}) {
    const localVarRequestOptions: AxiosRequestConfig = { method: 'DELETE' };
    const { date } = request;
    const localVarUrl = '/user/carts';
    const localVarUrlObj = new URL(localVarUrl, DUMMY_BASE_URL);
    const localVarHeaderParameter: RawAxiosRequestHeaders = {};
    const localVarQueryParameter: Record<string, any> = {};

    if (date !== undefined) {
      localVarQueryParameter['date'] =
        (date as any) instanceof Date
          ? (date as any).toISOString().substr(0, 10)
          : date;
    }

    setSearchParams(localVarUrlObj, localVarQueryParameter);
    localVarRequestOptions.headers = { ...localVarHeaderParameter };
    const axiosRequestArgs = {
      ...localVarRequestOptions,
      url: getBaseUrl() + toPathString(localVarUrlObj),
    };
    return axios.request<void>(axiosRequestArgs);
  },

  getCartForDate(request: GetCartForDateParams = {}) {
    const localVarRequestOptions: AxiosRequestConfig = { method: 'GET' };
    const { date } = request;
    const localVarUrl = '/user/carts';
    const localVarUrlObj = new URL(localVarUrl, DUMMY_BASE_URL);
    const localVarHeaderParameter: RawAxiosRequestHeaders = {};
    const localVarQueryParameter: Record<string, any> = {};

    if (date !== undefined) {
      localVarQueryParameter['date'] =
        (date as any) instanceof Date
          ? (date as any).toISOString().substr(0, 10)
          : date;
    }

    setSearchParams(localVarUrlObj, localVarQueryParameter);
    localVarRequestOptions.headers = { ...localVarHeaderParameter };
    const axiosRequestArgs = {
      ...localVarRequestOptions,
      url: getBaseUrl() + toPathString(localVarUrlObj),
    };
    return axios.request<CartResponse>(axiosRequestArgs);
  },

  getMyCartsForSpecifiedDates(request: GetMyCartsForSpecifiedDatesParams = {}) {
    const localVarRequestOptions: AxiosRequestConfig = { method: 'GET' };
    const { cartDateFrom, cartDateTo } = request;
    const localVarUrl = '/user/carts/all';
    const localVarUrlObj = new URL(localVarUrl, DUMMY_BASE_URL);
    const localVarHeaderParameter: RawAxiosRequestHeaders = {};
    const localVarQueryParameter: Record<string, any> = {};

    if (cartDateFrom !== undefined) {
      localVarQueryParameter['cartDateFrom'] =
        (cartDateFrom as any) instanceof Date
          ? (cartDateFrom as any).toISOString().substr(0, 10)
          : cartDateFrom;
    }
    if (cartDateTo !== undefined) {
      localVarQueryParameter['cartDateTo'] =
        (cartDateTo as any) instanceof Date
          ? (cartDateTo as any).toISOString().substr(0, 10)
          : cartDateTo;
    }

    setSearchParams(localVarUrlObj, localVarQueryParameter);
    localVarRequestOptions.headers = { ...localVarHeaderParameter };
    const axiosRequestArgs = {
      ...localVarRequestOptions,
      url: getBaseUrl() + toPathString(localVarUrlObj),
    };
    return axios.request<Array<CartResponse>>(axiosRequestArgs);
  },

  recreateCartFromOrder(request: RecreateCartFromOrderParams) {
    const localVarRequestOptions: AxiosRequestConfig = { method: 'POST' };
    const { orderId } = request;
    const localVarUrl = '/user/carts/{orderId}'.replace(
      `{${'orderId'}}`,
      encodeURIComponent(String(orderId)),
    );
    const localVarUrlObj = new URL(localVarUrl, DUMMY_BASE_URL);
    const localVarHeaderParameter: RawAxiosRequestHeaders = {};
    const localVarQueryParameter: Record<string, any> = {};

    setSearchParams(localVarUrlObj, localVarQueryParameter);
    localVarRequestOptions.headers = { ...localVarHeaderParameter };
    const axiosRequestArgs = {
      ...localVarRequestOptions,
      url: getBaseUrl() + toPathString(localVarUrlObj),
    };
    return axios.request<CartResponse>(axiosRequestArgs);
  },

  removeItemFromCart(request: RemoveItemFromCartParams) {
    const localVarRequestOptions: AxiosRequestConfig = { method: 'DELETE' };
    const { itemId } = request;
    const localVarUrl = '/user/carts/items/{itemId}'.replace(
      `{${'itemId'}}`,
      encodeURIComponent(String(itemId)),
    );
    const localVarUrlObj = new URL(localVarUrl, DUMMY_BASE_URL);
    const localVarHeaderParameter: RawAxiosRequestHeaders = {};
    const localVarQueryParameter: Record<string, any> = {};

    setSearchParams(localVarUrlObj, localVarQueryParameter);
    localVarRequestOptions.headers = { ...localVarHeaderParameter };
    const axiosRequestArgs = {
      ...localVarRequestOptions,
      url: getBaseUrl() + toPathString(localVarUrlObj),
    };
    return axios.request<void>(axiosRequestArgs);
  },

  updateCartGeneralComment(request: UpdateCartGeneralCommentParams) {
    const localVarRequestOptions: AxiosRequestConfig = { method: 'PATCH' };
    const { updateCartCommentRequest, date } = request;
    const localVarUrl = '/user/carts/comment';
    const localVarUrlObj = new URL(localVarUrl, DUMMY_BASE_URL);
    const localVarHeaderParameter: RawAxiosRequestHeaders = {};
    const localVarQueryParameter: Record<string, any> = {};

    if (date !== undefined) {
      localVarQueryParameter['date'] =
        (date as any) instanceof Date
          ? (date as any).toISOString().substr(0, 10)
          : date;
    }

    localVarHeaderParameter['Content-Type'] = 'application/json';
    setSearchParams(localVarUrlObj, localVarQueryParameter);
    localVarRequestOptions.headers = { ...localVarHeaderParameter };
    localVarRequestOptions.data = serializeDataIfNeeded(
      updateCartCommentRequest,
      localVarRequestOptions,
    );
    const axiosRequestArgs = {
      ...localVarRequestOptions,
      url: getBaseUrl() + toPathString(localVarUrlObj),
    };
    return axios.request<CartResponse>(axiosRequestArgs);
  },

  updateCartItemQuantity(request: UpdateCartItemQuantityParams) {
    const localVarRequestOptions: AxiosRequestConfig = { method: 'PUT' };
    const { itemId, updateCartItemRequest } = request;
    const localVarUrl = '/user/carts/items/{itemId}'.replace(
      `{${'itemId'}}`,
      encodeURIComponent(String(itemId)),
    );
    const localVarUrlObj = new URL(localVarUrl, DUMMY_BASE_URL);
    const localVarHeaderParameter: RawAxiosRequestHeaders = {};
    const localVarQueryParameter: Record<string, any> = {};

    localVarHeaderParameter['Content-Type'] = 'application/json';
    setSearchParams(localVarUrlObj, localVarQueryParameter);
    localVarRequestOptions.headers = { ...localVarHeaderParameter };
    localVarRequestOptions.data = serializeDataIfNeeded(
      updateCartItemRequest,
      localVarRequestOptions,
    );
    const axiosRequestArgs = {
      ...localVarRequestOptions,
      url: getBaseUrl() + toPathString(localVarUrlObj),
    };
    return axios.request<CartItemResponse>(axiosRequestArgs);
  },
};
